import React, { Component } from "react";
import Page from '../../Page';
import Intro from '../../components/Intro/Intro.js';
import Quote from '../../components/Quote/Quote.js';
import Text from '../../components/Text/Text';
import TextFullImage from '../../components/TextFullImage/TextFullImage.js';
import fullimageImage from '../../img/headerkopie.jpg';
import quoteImage from '../../img/Humor-op-socialmedia.jpg';
import FullWidthImage from '../../components/FullWidthImage/FullWidthImage';
import fullWidthImg from '../../img/iPhoneXSMockupsVol08D.jpg';
import data from '../../components/magazine.json';
import DocumentMeta from "react-document-meta";
import PageNumber from "../../components/PageNumber/PageNumber";
import Share from "../../components/Share/Share";
import MetaTags from "react-meta-tags";

const introtekst = data.magazine.pages[8]["intro-text"];

const quote = data.magazine.pages[8].quote;
const author = data.magazine.pages[8].author;
const website = data.magazine.pages[8].website;

const title =  data.magazine.pages[8].title;
const paragraphs1 = data.magazine.pages[8]["paragraphs-first-part"];
const paragraphs2 = data.magazine.pages[8]["paragraphs-second-part"];

class Tenthpage extends Component {
  componentDidMount(){
    const prevLink = '/appart-me/editie-9/influencers-bestaan-al-veel-langer-alleen-werden-ze-niet-zo-genoemd';
    const nextLink = '/appart-me/editie-9/space32-door-de-ogen-van-appart';
    const prevPossible = true;
    const nextPossible = true;
    const isScrollable = true;
    this.props.updatelinks(prevLink, nextLink, prevPossible, nextPossible, isScrollable);
  }

  render() {
    console.log(data);
    const meta = {
      title: 'Appart Me | Editie 9 | ' + author + ' | ' + data.magazine.pages[8]["intro-title"] ,
    };
    return (
      <Page>
        <MetaTags>
          <title>{ meta.title }</title>
          <meta name="description" content="5 tips voor het gebruik van humor op social media." />
          <meta name="og:title" content="5 tips voor het gebruik van humor op social media." />
          <meta name="og:description" content="5 tips voor het gebruik van humor op social media." />
          <meta name="og:image" content={"https://appart.nl/" + fullimageImage} />
          <meta name="twitter:image" content={"https://appart.nl/" + fullimageImage} />
        </MetaTags>
        <Intro title={data.magazine.pages[8]["intro-title"]} subtitle={data.magazine.pages[8]["intro-sub-title"]} content={introtekst} background={fullimageImage}/>
        <TextFullImage title={title} paragraphs={paragraphs1} image={fullimageImage} alt="papegaai"/>
        <FullWidthImage image={fullWidthImg} />
        <Text paragraphs={paragraphs2} />
        <Share />
        <Quote quote={quote} author={author} QuoteSize="contain" website={website} classes='quote-block' image={quoteImage}/>
        <PageNumber pageNumber={11} />
      </Page>
    )
  }
}

export default Tenthpage;
